import React, {useEffect, useRef} from 'react';
import {useUser} from '@lore/auth';
import ParentLayout from './Layout';
import useRouter from '../../hooks/useRouter';
import Loader from '../../components/Loader';
import {useQueryMutation} from '@lore/query-connect';

export default function Layout() {
  const {history} = useRouter();

  const user = useUser();

  const mutation = useQueryMutation('offer.create');
  const {success, request} = mutation;

  // prevents duplicate POSTs (including React 18 StrictMode dev behavior)
  const hasCreatedRef = useRef(false);

  useEffect(() => {
    if (success) {
      history.push(`/post-offer/${request.id}`, {replace: true});
    }
  }, [success, history, request?.id]);

  useEffect(() => {
    if (!user?.id) return;
    if (hasCreatedRef.current) return;

    hasCreatedRef.current = true;
    mutation.mutate({
      creatorId: user.id
    });
  }, [user?.id]);

  return (
    <ParentLayout
      page="Create offer"
      title={(
        <Loader/>
      )}
    >
      <div className="px-16 lg:px-32 pt-32">
        <Loader/>
      </div>
    </ParentLayout>
  );
};
